module.exports = __webpack_public_path__ + "static/media/l2e-fonts.527592d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/l2e-fonts.png
// module id = 551
// module chunks = 0